module.exports = __webpack_public_path__ + "img/señalización_i_o_link.dfbfd729.jpg";